var map = {
	"./how-cookstoves-create-credits.json": 302,
	"./offsetting-after-reducing.json": 596,
	"./what-is-a-carbon-credit.json": 563,
	"content/posts/how-cookstoves-create-credits.json": 302,
	"content/posts/offsetting-after-reducing.json": 596,
	"content/posts/what-is-a-carbon-credit.json": 563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 994;